import NamedDto from 'modules/base/dto/NamedDto';

export class OptimizerLogFieldEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
	}

	/**
	 * @typedef {Object} _OptimizerLogFieldEditDtoProps
	 * @property {string} type
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizerLogFieldEditDtoProps} OptimizerLogFieldEditDtoProps
	 */
	/**
	 *
	 * @param {OptimizerLogFieldEditDtoProps} props
	 * @returns {OptimizerLogFieldEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		return this;
	}
}

export default OptimizerLogFieldEditDto;
